<script setup lang="ts">
import { LANGUAGE } from '@/env';
import VueDatePicker from '@vuepic/vue-datepicker';
import { computed } from 'vue';
import { cs, sk } from 'date-fns/locale';
import { urlFilters } from '@/composables/urlFilters';
import { useI18n } from 'vue-i18n';
import '@vuepic/vue-datepicker/dist/main.css';
import styles from '@/assets/sass/components/date-filter.module.scss';


const { filters, updateFilters } = urlFilters();
const { t } = useI18n();

const selectedDate = computed<[string, string]>({
    get() {
        return filters.date;
    },

    set(newSelection) {
        updateFilters({ date: newSelection });
    }
});

</script>
<template>
    <VueDatePicker :class="styles.datepicker" v-model="selectedDate" :range="{ showLastInRange: false }"
        model-type="yyyy-MM-dd" :clearable="false" :enable-time-picker="false" :min-date="new Date(
            Date.now() + 4 * 24 * 60 * 60 * 1000
        )
            " :locale="LANGUAGE" :format-locale="LANGUAGE === 'cs' ? cs : sk" format="P"
        :selectText="t('LABELS.select')" :cancelText="t('LABELS.cancel')" auto-apply :hide-input-icon="true">
    </VueDatePicker>
</template>
